/* global modForm modUtils Modalytics */
import { appendLeadTokenScriptToBody } from '../../helpers';
/**
 * Load lead token scripts (TrustedForm, Journaya) triggers via GTM's data layer
 */
export function loadLeadTokenScriptsTriggers() {
	const isModernizeDomain = modUtils.getLandingPage().indexOf('modernize.com') > 0 && !modUtils.getLandingPage().includes('bestcompany');
	const isModernizeQuotePage = isModernizeDomain && window.location.pathname.startsWith('/quote');

	// Set landingPageSubdirectory if isModernizeQuotePage
	if (isModernizeQuotePage) {
		let subdirectory = window.location.pathname;
		if (!subdirectory.endsWith('/')) {
			subdirectory += '/';
		}
		modForm.opts.landingPageSubdirectory = subdirectory;
	}

	if (modForm.areLeadTokenScriptsLoaded) {
		modForm.opts.form.querySelectorAll('.btn-primary, .btn--primary, input[type="radio"]').forEach(function(element) {
			if (!element) {
				return;
			}

			element.removeEventListener('click', function(e) {
				e.stopPropagation();
				loadLeadTokenScriptsTriggers();
			});
		});
		return;
	}

	const $body = document.querySelector('body');
	let scriptsURL = isModernizeDomain ? '' : '/';
	const scriptsFolder = modForm.opts.isVite ? 'resources/scripts/' : 'scripts/';
	const shouldLoadRecaptcha = ((isModernizeDomain && !isModernizeQuotePage) || modForm.opts.showRecaptchaForDirectTraffic) && !modForm.opts.disableRecaptcha;

	if (window.isWordpress) {
		scriptsURL = modUtils.getLandingPage().indexOf('modernize.local') > 0 ? '/wp-content/themes/modernize/source/' : '/wp-content/themes/modernize/dist/';
	}

	if (modForm.opts.isGutenbergWP) {
		scriptsURL = '/wp-content/themes/modernize/public/';
	}

	if (modUtils.getEnv() !== 'local' && modForm.opts.landingPageSubdirectory !== '') {
		scriptsURL = modForm.opts.landingPageSubdirectory;
	}

	// When TrustedForm token input gets appended to the body
	if (!modForm.trustedFormObserver) {
		modForm.trustedFormObserver = new MutationObserver(function(mutations, observer) {
			if (document.contains(document.querySelector('[name=xxTrustedFormToken]'))) {
				modForm.loadedScripts.push('trusted');
				if (!shouldLoadRecaptcha || modForm.loadedScripts.includes('recaptcha')) {
					modForm.areLeadTokenScriptsLoaded = true;
				}
				observer.disconnect();
			}
		});

		modForm.trustedFormObserver.observe($body, { childList: true, subtree: true });
	}

	if (shouldLoadRecaptcha && !modForm.recaptchaFormObserver) {
		// When Recaptcha token input gets appended to the body
		modForm.recaptchaFormObserver = new MutationObserver(function(mutations, observer) {
			if (document.contains(document.querySelectorAll('.grecaptcha-badge')[0])) {
				modForm.loadedScripts.push('recaptcha');
				if (modForm.loadedScripts.includes('trusted')) {
					modForm.areLeadTokenScriptsLoaded = true;
				}
				observer.disconnect();
			}
		});

		modForm.recaptchaFormObserver.observe($body, { childList: true, subtree: true });
	}

	if (!modForm.opts.useContractorApi) {
		// Load TrustedForm Script + If script is being injected again, remove it first
		const $TFScript = document.getElementById('trustedFormScript');
		if ($TFScript) {
			$TFScript.nextElementSibling?.closest('noscript')?.remove();
			$TFScript.remove();
			modForm.trustedFormRetryCount = (modForm.trustedFormRetryCount || 0) + 1;
			Modalytics.heap('track', ['TrustedForm Retry', { retry: modForm.trustedFormRetryCount }]);
		}
		appendLeadTokenScriptToBody(`${scriptsURL}${scriptsFolder}trusted-form.html`);

		// Load Recaptcha Script
		if (shouldLoadRecaptcha) {
			appendLeadTokenScriptToBody(`${scriptsURL}${scriptsFolder}recaptcha.html`);
		}
	}
}
